import React, { useEffect, useState } from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AlertTemplate, { AlertTypes } from '@components/Alert/Alert';
import ConferenceTemplate from '@components/Conference/Conference';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import { ACCESS_TOKEN_KEY, IS_PROD, ROUTES } from '../../constants';
import { EventStates } from '../../interfaces/Calendar';
import { IConferenceItem } from '../../interfaces/Conference';
import { calendarApi } from '../../services/calendar.service';

interface IConference {
    status: number;
    conf?: IConferenceItem;
}

const Conferences: NextPage<IConference> = (props) => {
    if (props?.status && props?.status !== 200) return <AlertTemplate type={AlertTypes.error} />;

    return (
        <>
            <NextSeo
                title={`${props.conf?.conference?.seo?.title || ''} | Studiow.cz`}
                description={props.conf?.conference?.seo?.description}
                noindex={props.conf?.conference?.state === EventStates.NO_VISIBLE || !IS_PROD}
                nofollow={props.conf?.conference?.state === EventStates.NO_VISIBLE || !IS_PROD}
            />
            <HeaderTemplate />
            <ConferenceTemplate conf={props?.conf} />
            <FooterTemplate />
        </>
    );
};

Conferences.getInitialProps = async (ctx: any) => {
    try {
        const token = ctx?.res?.req?.cookies?.[ACCESS_TOKEN_KEY];
        const { data: conference } = await calendarApi.getConferenceSlug(ctx.query.slug as string, token);
        const { data: dates } = await calendarApi.getConferenceDates(ctx.query.slug as string, token);

        return {
            status: 200,
            conf: { ...conference, dates },
        };
    } catch (error: any) {
        if (error?.response?.status === 404) {
            return ctx.res.writeHead(302, { Location: ROUTES.NOT_FOUND }).end();
        }

        return {
            status: 500,
        };
    }
};

export default Conferences;
